import { useState, useEffect } from "react"
import { useQuery } from "react-query"
import Select from "react-select"
import axios from "axios"
import cn from "classnames"
import customStyles from "./styles"
import DropdownIndicatorForSelect from "components/DropdownIndicatorForSelect"

const fetchDetails =
  (endpoint: string, active: boolean) => async (props: any) => {
    if (!active) return []
    const { data } = await axios.get(endpoint)

    return data.results ?? data
  }

const TankProductPicker = (props: {
  selected?: number
  isDisabled?: boolean
  location?: number
  tank_id?: number
  label?: string
  prefix?: string
  className?: string
  errorText?: string
  onSelect?: (item: any) => void
}) => {
  const [data, setData] = useState<any[]>([])
  const endpoint = `locations/${props.location}/tanks`
  const { data: tankData, isLoading } = useQuery(
    ["tanks", props.location],
    fetchDetails(endpoint, !!props.location)
  )

  const { data: products, isLoading: isLoadingProducts } = useQuery(
    ["products"],
    fetchDetails("/products/?page_size=10000&ordering=code", true)
  )
  const errorColor = props.errorText ? "red" : "#cbdfea"

  useEffect(() => {
    const productArray = products ?? []
    if (!productArray.length) return
    if (isLoading) return

    const productData = productArray.map((product: any) => {
      return {
        value: product.id,
        label: [props.prefix, product.code].filter((x) => !!x).join(" - "),
        data: {
          blended: product.blended,
          components: product.components,
          product_id: product.id,
          product: product.id,
          product_name: product.code,
          tank_id: props.tank_id,
        },
      }
    })

    if (props.tank_id) return setData(productData)

    const outputData = (tankData ?? []).map((item: any) => {
      const pref = item.preferences?.[0] ?? {}
      return {
        label: [item.name, item.product?.code].filter((x) => !!x).join(" - "),
        value: item?.product?.id,
        data: {
          product: item?.product?.id,
          blended: item?.product?.blended,
          components: item?.product?.components,
          product_id: item?.product?.id,
          product_name: `${item.name} - ${item.product?.code}`,
          tank_name: item.name,
          terminal: pref.terminal,
          terminal_label: pref.terminal,
          terminal_id: pref.terminal,
          supplier: pref.supplier,
          supplier_label: pref.supplier_name,
          loading_number: pref.loading_number,
          description: pref.description,
          wholesaler: pref.wholesaler,
          loading_number_id: pref.loading_number_id,
          preferred_source: {
            terminal: pref.terminal,
            terminal_label: pref.terminal,
            source_name: `${pref.terminal}: ${pref.supplier}`,
            supplier: pref.supplier,
            id: pref.supplier,
          },
          tank_id: props.tank_id ?? item.id,
        },
      }
    })

    setData([...outputData, ...productData])
  }, [isLoading, tankData, products])

  if (isLoading || isLoadingProducts || !data.length) return null

  return (
    <div className={cn("flex-c-box", props.className)}>
      {!props.label ? null : (
        <>
          <span style={{ color: "#486f88", fontWeight: "bold" }}>
            {props.label}
          </span>
          <div style={{ marginTop: 4 }} />
        </>
      )}

      <Select
        components={
          props.errorText
            ? { DropdownIndicator: DropdownIndicatorForSelect }
            : {}
        }
        isDisabled={props.isDisabled}
        placeholder={
          tankData?.length ? "Choose Tank/Product" : "Choose Product"
        }
        options={data}
        onChange={props.onSelect}
        styles={customStyles({
          marginRight: 0,
          border: `1px solid ${errorColor}`,
        })}
        defaultValue={data?.find((item) => item.value === props.selected)}
      />
    </div>
  )
}

export default TankProductPicker
